// src/components/Footer.js
import React from 'react';

const Footer = () => (
  <footer style={{ backgroundColor: '#1B3B6F', color: 'white', padding: '1rem', textAlign: 'center' }}>
    &copy; 2025 USIU-Africa Asset Recovery System. All rights reserved.
  </footer>
);

export default Footer;
